import * as ResourcesHubActions from "../../actions/ResourcesHubActions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as API from "../../utils/apiPath";
import { agent } from "../../utils/agent";
import { renderGlobalModal } from "../../utils/helpers";

const Index = () => {

  agent
    .post(API.CKEDITOR_IMAGE_UPLOAD, {})
    .then((response) => {
      if (response.status === 200) {
        renderGlobalModal({
          message: response.data.message,
        });
      }
    })
    .catch((error) => {
      renderGlobalModal({
        message: error.response?.data?.message || "An error occurred",
      });
    });

  return true;
};

function mapStateToProps(state) {
  return {

  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      ...ResourcesHubActions
    }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
